/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Notes_OnInputs */



/**
* | output |
* | --- |
* | "Notetaker on" |
*
* @param {Meeting_Notes_OnInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_notes_on = /** @type {((inputs?: Meeting_Notes_OnInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Notes_OnInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Notetaker aan")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Notetaker activé")
	return /** @type {LocalizedString} */ ("Notetaker on")
});